import { RenderIfProps } from "./helper";

const RenderIf = ({ children, condition, fallback = <></> } : RenderIfProps) => 
(
    Boolean(condition) ? children : fallback
)

export default RenderIf;